export const PLACEMENT_DETAILS_BASEURL = '/placementDetails';

export const PLACEMENT_OVERVIEW_BASEURL = '/placementsOverview';
